import { Column, Flexbox } from "../theme/grid";
import { Heading, Paragraph, PcaHeading } from "../theme/typography";
import React, { useEffect, useState } from "react";

import BoiReactMarkdown from "../boi-markdown/boi-markdown";
import { Box } from "../theme/containers";
import { Fade } from "../transitions/fade";
import IconBlock from "../icon-block/icon-block";
import LoadingIcon from "../loading-icon/loading-icon";
import { SVGInfoIcon } from "../svg-animated/svg-animated";
import defaultTheme from "../theme/theme-test-override";
import { remCalc } from "../theme/style-utils-coras-nua";
import { ThemeTemplate } from "../theme/theme-template";
import styled from "styled-components";

function checkIfHelpIsEmpty(helpData: any) {
    return helpData
        ? helpData["blocks"] && helpData["blocks"].toString() === ""
            ? true
            : false
        : true;
}

const HelpComponent = ({ helpData } : { helpData: any }) => {
    const helpMessagesDefault = [{ content: "", cssClass: "" }];
    const [helpMessages, setHelpMessages] = useState(helpMessagesDefault);
    const [generalCssClasses, setGeneralCssClasses] = useState("");

    useEffect(() => {
        let isMounted = true;
        if (helpData && !checkIfHelpIsEmpty(helpData)) {
            const helpMessagesArray = [];
            const numberOfBlocks = helpData["blocks"] || 0;
            for (let i = 0; i < parseInt(numberOfBlocks); i++) {
                helpMessagesArray.push({
                    content: helpData[`blocks_${i}_content`].toString(),
                    cssClass: helpData[`blocks_${i}_css_classes`].toString()
                });
            }
            if (isMounted) {
                setHelpMessages(helpMessagesArray);
                setGeneralCssClasses(helpData["general_css_classes"] || "");
            }
        }
        return () => {
            isMounted = false;
        };
    }, [helpData]);

    return JSON.stringify(helpMessages) ===
        JSON.stringify(helpMessagesDefault) ? (
        <LoadingIcon />
    ) : (
        <Fade in={true}>
            <HelpLayer className={`${generalCssClasses}`}>
                {helpMessages.map((helpMessage, index) => (
                    <BoiReactMarkdown
                        key={index}
                        className={helpMessage.cssClass}
                    >
                        {helpMessage.content}
                    </BoiReactMarkdown>
                ))}
            </HelpLayer>
        </Fade>
    );
};

const HelpLayer = styled(Box)`
    .icon-bg {
        &.phone {
            background-image: url("data:image/svg+xml,%3C?xml version='1.0' encoding='UTF-8'?%3E %3Csvg width='36px' height='36px' viewBox='0 0 36 36' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E %3Ctitle%3EIcon - give us a call%3C/title%3E %3Cg id='icon-phone' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E %3Cpath d='M9.32640066,6.16064257 C10.0298876,6.16282194 10.7037654,6.44351137 11.2001135,6.94109772 L11.2001135,6.94109772 L14.9770466,10.6961178 C16.0121003,11.7403652 16.0121003,13.421616 14.9770466,14.4658635 L14.9770466,14.4658635 L12.7639999,16.6746988 C13.7377404,17.8085676 14.8000029,18.9718876 15.9212799,20.1057564 C17.0425569,21.2396252 18.2228484,22.2851406 19.3588791,23.2570281 L19.3588791,23.2570281 L21.5719258,21.0481928 C22.0727412,20.5482236 22.7520568,20.2673349 23.4603923,20.2673349 C24.1687279,20.2673349 24.8480435,20.5482236 25.3488589,21.0481928 L25.3488589,21.0481928 L29.1110383,24.8179384 C29.6147323,25.3133295 29.8983315,25.9896472 29.8983315,26.6954485 C29.8983315,27.4012497 29.6147323,28.0775674 29.1110383,28.5729585 L29.1110383,28.5729585 L28.166805,29.5153949 L26.2783385,31.4002677 L25.7914682,31.8862115 C25.2960459,32.3851719 24.6215697,32.6661105 23.9177553,32.6666667 L23.9177553,32.6666667 L23.5931751,32.6666667 C21.3358675,32.3721553 16.4819184,31.0615797 10.7279969,25.3038822 C4.97407546,19.5461847 3.64624743,14.7309237 3.35117453,12.4631861 C3.25695096,11.6487611 3.53930904,10.8358166 4.11836406,10.2543507 L4.11836406,10.2543507 L4.60523434,9.78313253 L6.49370087,7.89825971 L7.43793413,6.95582329 C7.93789084,6.45462192 8.6177997,6.17363289 9.32640066,6.17536814 L9.32640066,6.17536814 L9.32640066,6.16064257 Z M9.25263244,7.63319946 L9.32640066,7.64792503 C9.00856062,7.64141463 8.70289127,7.7698726 8.48544291,8.00133869 L8.48544291,8.00133869 L7.54120964,8.9437751 L5.65274312,10.8139224 L5.16587284,11.2998661 C4.90509513,11.5581103 4.77965702,11.9228216 4.82653901,12.2864793 C5.09210461,14.4364123 6.36091806,18.8688086 11.7755057,24.2583668 C17.1900933,29.647925 21.6161867,30.9290495 23.7849725,31.1941098 L23.7849725,31.1941098 L23.9177553,31.1941098 C24.207068,31.1696415 24.4785892,31.0445625 24.6849449,30.8406961 L24.6849449,30.8406961 L25.1718151,30.3547523 L27.045528,28.4698795 L27.9897613,27.5274431 C28.2216687,27.3104085 28.3503716,27.0053209 28.3438488,26.6880857 C28.3433285,26.3722355 28.2157542,26.0698232 27.9897613,25.8487282 L27.9897613,25.8487282 L24.2275819,22.0937082 C24.0042242,21.8708639 23.7024148,21.7440281 23.3866241,21.7402945 C23.0701718,21.7408138 22.7671829,21.8681453 22.5456664,22.0937082 L22.5456664,22.0937082 L20.3326196,24.2878179 C20.0566211,24.5688637 19.679396,24.7279513 19.2851109,24.729585 C18.9385466,24.7261322 18.6042623,24.6010142 18.3408776,24.3761714 C17.0573105,23.3012048 15.8622653,22.2115127 14.8000029,21.1512718 C13.7377404,20.0910308 12.6459707,18.8982597 11.5689547,17.6171352 C11.0775553,17.0318163 11.1159899,16.1686836 11.6574765,15.6291834 L11.6574765,15.6291834 L13.8557696,13.4203481 C14.0817625,13.1992531 14.2093368,12.8968408 14.2098571,12.5809906 C14.2061164,12.2658009 14.0790388,11.9645658 13.8557696,11.7416332 L13.8557696,11.7416332 L10.0935902,7.98661312 C9.87207367,7.76105028 9.56908478,7.63371878 9.25263244,7.63319946 L9.25263244,7.63319946 Z M17.2786152,3.33333333 C25.7604228,3.37362753 32.6262956,10.2264347 32.6666667,18.6921017 C32.6508118,19.0953251 32.3185339,19.413965 31.9142308,19.4136555 C31.7185725,19.409788 31.5324716,19.3284826 31.3968878,19.1876334 C31.2613041,19.0467842 31.1873499,18.857935 31.1913022,18.6626506 C31.1509708,11.0265093 24.9588228,4.84614484 17.3081225,4.80589023 C17.1113303,4.81391403 16.9197773,4.74145066 16.7777511,4.60525383 C16.635725,4.46905701 16.5555225,4.28091883 16.5556856,4.08433735 C16.5553756,3.68080366 16.874623,3.34915807 17.2786152,3.33333333 Z M17.2491079,7.63308579 C20.2063975,7.62000821 23.0528849,8.75538026 25.1865688,10.7991968 C27.1897016,12.9501605 28.3157024,15.770309 28.3438488,18.7068273 C28.3280025,19.1019172 28.0023266,19.4139711 27.6061665,19.4136553 C27.4104668,19.405998 27.2258503,19.3209816 27.0930091,19.1773442 C26.9601679,19.0337068 26.8900073,18.8432398 26.8979916,18.647925 C26.8533908,16.1159947 25.8765578,13.6890429 24.1538136,11.8299866 C22.3008205,10.0879669 19.8536536,9.11412136 17.3081225,9.10575636 C17.1103055,9.12226838 16.9146267,9.0551546 16.7687626,8.92076709 C16.6228986,8.78637957 16.540319,8.59705767 16.5409329,8.39892905 C16.5329487,8.20361425 16.6031093,8.01314728 16.7359505,7.86950988 C16.8687916,7.72587249 17.0534082,7.64085605 17.2491079,7.63308579 Z' id='Combined-Shape' fill='%23161616' fill-rule='nonzero'%3E%3C/path%3E %3C/g%3E %3C/svg%3E");
            background-position: top ${remCalc(30)} right ${remCalc(30)};
            background-repeat: no-repeat;
        }
    }
    .u-p-flex-column-50 {
        p {
            display: flex;
            flex-direction: column;
            width: 50%;
            margin-bottom: 0;
        }
    }
`;
HelpLayer.defaultProps = {
    theme: {
        ...defaultTheme
    } as ThemeTemplate
};
const HelpPCA = () => {
    return (
        <div>
            <PcaHeading fontWeight="normal" textAlign="left">
                Got a question or need assistance with your application?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <a href="tel:0818200374">081 820 0374</a> (RoI)
                    <br /> or
                    <br />
                    <a href="tel:0035312500374">+353 1 250 0374</a> (outside
                    RoI)
                </Paragraph>
                <Paragraph mb={0}>
                    Office hours
                    <br />
                    Monday - Friday
                    <br />
                    9am - 6pm
                </Paragraph>
            </IconBlock>
        </div>
    );
};
const HelpPCANI = () => {
    return (
        <div>
            <PcaHeading fontWeight="normal" textAlign="left">
                Got a question or need assistance with your application?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <a href="tel:+448000850444">+44 800 0850 444</a>
                </Paragraph>
                <Paragraph mb={0}>
                    Office hours
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </div>
    );
};
const HelpMortgageArrears = () => {
    return (
        <div>
            <PcaHeading fontWeight="normal" textAlign="left">
                Got a question or need help?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <strong>
                        <a href="tel:+35314883046">01 488 3046</a>{" "}
                    </strong>{" "}
                    (RoI)
                    <br />
                    or
                    <br />
                    <strong>
                        <a href="tel:+35314883046">+353 1 488 3046</a>{" "}
                    </strong>{" "}
                    (outside RoI) and select option 2.
                </Paragraph>
                <Paragraph mb={0}>
                    <strong>Office hours</strong>
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm, Monday to Friday excluding bank and public
                    holidays.
                </Paragraph>
            </IconBlock>
        </div>
    );
};
const HelpPersonalLoans = () => {
    return (
        <div>
            <PcaHeading fontWeight="normal" textAlign="left">
                Got a question or need help?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <a href="tel:0818200469">0818 200 469</a>
                </Paragraph>
                <Paragraph mb={0}>
                    Office hours
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </div>
    );
};

const HelpPersonalOverdrafts = () => {
    return (
        <div>
            <PcaHeading fontWeight="normal" textAlign="left">
                Got a question or need help?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <a href="tel:0818200402">0818 200 402</a>
                </Paragraph>
                <Paragraph mb={0}>
                    Office hours
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </div>
    );
};

const HelpSBALoans = () => {
    return (
        <>
            <SVGInfoIcon className="u-mt-auto u-mx-auto" />
            <Heading className={"u-mb-3 u-mt-4 u-text-centre"}>
                Need help with your application?
            </Heading>

            <Paragraph mb="2rem" className="u-text-centre">
                Contact us from Mon-Fri, 9am - 5pm.
            </Paragraph>
            <Box p="1.25rem" backgroundColor="monotoneMidLight">
                <Flexbox mx="0" className="u-text-centre">
                    <Column xs={6}>
                        <Paragraph>Republic of Ireland</Paragraph>
                        <Paragraph>
                            <a href="tel:0818200345">0818 200 345</a>
                        </Paragraph>
                    </Column>
                    <Column xs={6}>
                        <Paragraph>From abroad</Paragraph>
                        <Paragraph>
                            <a href="tel:+35312500345">+353 1 250 0345</a>
                        </Paragraph>
                    </Column>
                </Flexbox>
            </Box>
        </>
    );
};
const HelpSBAOverdrafts = () => {
    return (
        <>
            <SVGInfoIcon className="u-mt-auto u-mx-auto" />
            <Heading className={"u-mb-3 u-mt-4 u-text-centre"}>
                Need help with your application?
            </Heading>

            <Paragraph mb="2rem" className="u-text-centre">
                Contact us from Mon-Fri, 9am - 5pm.
            </Paragraph>
            <Box p="1.25rem" backgroundColor="monotoneMidLight">
                <Flexbox mx="0" className="u-text-centre">
                    <Column xs={6}>
                        <Paragraph>Republic of Ireland</Paragraph>
                        <Paragraph>
                            <a href="tel:0818200345">0818 200 345</a>
                        </Paragraph>
                    </Column>
                    <Column xs={6}>
                        <Paragraph>From abroad</Paragraph>
                        <Paragraph>
                            <a href="tel:+35312500345">+353 1 250 0345</a>
                        </Paragraph>
                    </Column>
                </Flexbox>
            </Box>
        </>
    );
};

const HelpBCALtd = () => {
    return (
        <>
            <PcaHeading>
                Got a question or need assistance with your application?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <strong>
                        <a href="tel:0818354454">081 835 4454</a>{" "}
                    </strong>{" "}
                    (ROI)
                    <br />
                    or
                    <br />
                    <strong>
                        <a href="tel:+35314044034">+353 1 404 4034</a>{" "}
                    </strong>{" "}
                    (outside ROI)
                </Paragraph>
                <Paragraph>
                    <strong>Office hours</strong>
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </>
    );
};
const HelpBCASt = () => {
    return (
        <>
            <PcaHeading>
                Got a question or need assistance with your application?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <strong>
                        <a href="tel:0818354454">081 835 4454</a>{" "}
                    </strong>{" "}
                    (ROI)
                    <br />
                    or
                    <br />
                    <strong>
                        <a href="tel:+35314044034">+353 1 404 4034</a>{" "}
                    </strong>{" "}
                    (outside ROI)
                </Paragraph>
                <Paragraph>
                    <strong>Office hours</strong>
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </>
    );
};
const HelpBIF = () => {
    return (
        <>
            <PcaHeading>
                Got a question or need assistance with your application?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <strong>
                        <a href="tel:0818664466">0818 66 44 66</a>
                    </strong>{" "}
                    (RoI)
                </Paragraph>
                <Paragraph>
                    <strong>Office hours</strong>
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </>
    );
};

const HelpTMO = () => {
    return (
        <>
            <PcaHeading>
                Got a question or need assistance with your application?
            </PcaHeading>
            <IconBlock icon="phone" position="right">
                <Paragraph>Call us on</Paragraph>
                <Paragraph>
                    <strong>
                        <a href="tel:0818664466">0818 66 44 66</a>
                    </strong>{" "}
                    (RoI)
                </Paragraph>
                <Paragraph>
                    <strong>Office hours</strong>
                    <br />
                    Monday - Friday
                    <br />
                    9am - 5pm
                </Paragraph>
            </IconBlock>
        </>
    );
};

export {
    HelpPCA,
    HelpPCANI,
    HelpMortgageArrears,
    HelpPersonalLoans,
    HelpPersonalOverdrafts,
    HelpSBALoans,
    HelpSBAOverdrafts,
    HelpBCALtd,
    HelpBCASt,
    HelpBIF,
    HelpTMO,
    HelpComponent,
    checkIfHelpIsEmpty
};
